function DriversViewController(trainService, config, __env, userService, $stateParams, $interval) {
  const ctrl = this;
  const env = __env;

  ctrl.$onInit = () => {
    ctrl.errorUrl = config + '/drivers-view/fallback-image';
    ctrl.isDemo = env.profile === 'DEMO';
    ctrl.staticImage = '../../images/driver-static-image.png'; //for demo purposes.
    ctrl.hasProfile = env.profile !== 'QR'; // Naming this way to hide project names from HTML
    ctrl.hasMaintenanceSwitch = env.profile === 'LU';
    ctrl.displayName = ctrl.hasProfile ? "driver's display" : "captain's display";
    ctrl.maintenanceMode = 1;
    ctrl.touchX = null;
    ctrl.touchY = null;
    ctrl.noContainers = false;
    ctrl.resX = 1024; // default size that train sends
    ctrl.resY = 768; // default size that train sends
    ctrl.trainId = $stateParams.consist;
    ctrl.userId = userService.getCurrentUserId();
    ctrl.fleetId = 1;
  };

  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.imagePromise);
    ctrl.stopDrivers();
  };

  ctrl.startDrivers = () => {
    ctrl.started = true;
    if (ctrl.isDemo) {
      getStaticImage();
    } else {
      trainService.startDriversView(ctrl.trainId).then(response => {
        ctrl.noContainers = true;
        if (response.statusCode === 400) {
          ctrl.noContainers = true;
        } else {
          ctrl.noContainers = false;
          ctrl.imagePromise = $interval(getImage, 1000);
        }
      });
      ctrl.loading = true;
    }
  };

  ctrl.stopDrivers = () => {
    ctrl.started = false;
    trainService.stopDriversView(ctrl.trainId).then(data => {

    });
    if (ctrl.imagePromise) $interval.cancel(ctrl.imagePromise);
  };

  ctrl.toggleMaintenance = () => {
    ctrl.maintenanceMode = ctrl.maintenanceMode ? 0 : 1;
  };

  ctrl.clickOnView = async (event) => {
    if (ctrl.fetchLoading) return;
    ctrl.fetchLoading = true;
    $interval.cancel(ctrl.imagePromise);
    const params = {
      fleetId: ctrl.fleetId,
      trainId: ctrl.trainId,
      resX: ctrl.resX,
      resY: ctrl.resY,
      touchX: event.offsetX,
      touchY: event.offsetY,
    };
    if (ctrl.hasMaintenanceSwitch) {
      params.maintenanceMode = ctrl.maintenanceMode;
    }
    let response = await trainService.getDriversView(params);
    if (response.statusCode === 200 && response.data.size > 0 && response.data.type === 'image/png') {
      ctrl.image = URL.createObjectURL(response.data);
    }
    ctrl.fetchLoading = false;
    ctrl.imagePromise = $interval(getImage, 1000);
  };

  const getImage = async () => {
    const params = {
      fleetId: ctrl.fleetId,
      trainId: ctrl.trainId,
      resX: ctrl.resX,
      resY: ctrl.resY,
    };
    if (ctrl.hasMaintenanceSwitch) {
      params.maintenanceMode = ctrl.maintenanceMode;
    }
    let response = await trainService.getDriversView(params);
    if (response.statusCode === 200 && response.data.size > 0 && response.data.type === 'image/png') {
      ctrl.image = URL.createObjectURL(response.data);
      ctrl.loading = false;
    }
  };
  
  const getStaticImage = () => {
    ctrl.image = ctrl.staticImage;
    ctrl.loading = false;
    ctrl.noContainers = false;  
  };
}

angular
  .module('gridlets.module')
  .controller('DriversViewController', DriversViewController);